// Client for Result History — autosaved query-result snapshots.
import { api } from './api.js';

// Client-side row cap: skip autosaving very large results (the server also caps).
export const AUTOSAVE_ROW_CAP = 20000;

// Save one rendered result set. payload: { connectionId, database, sql, columns:[name], rows:[[cell]] }.
export const saveResult = (payload) => api.post('/api/me/result-history', payload);

// List the caller's saved results (metadata, newest first).
export const listResults = () => api.get('/api/me/result-history').then((r) => r.results || []);

// Fetch one saved result, parsed back into { sql, columns:[{name}], rows, … }.
export const getResult = (id) => api.get(`/api/me/result-history/${id}`);

export const deleteResult = (id) => api.delete(`/api/me/result-history/${id}`);

// Direct CSV download URL for a saved result.
export const resultDownloadUrl = (id) => `/api/me/result-history/${id}/download`;
